import AbstractModel from './AbstractModel';

class CityModel extends AbstractModel {}

export default CityModel;
